import { clsx } from "clsx/lite";

type PspAvatarProps = {
  isDark?: boolean;
  name: string;
  size?: "small" | "medium" | "large";
};

export function PspAvatar({ isDark, name, size = "medium" }: PspAvatarProps) {
  return (
    <div
      className={clsx(
        "rounded-full",
        size === "small"
          ? "size-8 text-sm font-medium"
          : size === "medium"
            ? "size-12 text-base font-semibold"
            : "size-16 text-lg font-bold",
        "flex",
        "items-center",
        "justify-center",
        "duration-400",
        "ease-in-out",
        isDark
          ? "bg-font-secondary text-font-white"
          : "text-font-black group-hover:bg-white bg-canvas-secondary",
      )}
    >
      {name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()}
    </div>
  );
}
